import { axiosInstance } from "./";

const getCities = async (params) =>
  await axiosInstance.get("/cities", { params: { ...params, page: -1 } });

const getAreas = async (params) =>
  await axiosInstance.get("/areas", { params: { ...params, page: -1 } });

const getCarModels = async (params) =>
  await axiosInstance.get("/car_models", { params });

const getCarMakes = async (params) =>
  await axiosInstance.get("/vehicle_brands", { params });

const getCarTypes = async (params) =>
  await axiosInstance.get("/vehicle_types", { params });

const getStations = async (params) =>
  await axiosInstance.get("/stations", { params });

const getTeams = async (params) =>
  await axiosInstance.get("/owners/lookups", { params: { ...params } });

const getDrivers = async (params) =>
  await axiosInstance.get("/drivers/lookups", { params: { ...params } });

const getLevels = async (params) =>
  await axiosInstance.get("/levels", { params: { ...params } });

const getMaintenanceTypes = async (params) =>
  await axiosInstance.get("/maintenance_types", { params: { ...params } });

const getVerificationRequestsRejectionReasons = async (params) =>
  await axiosInstance.get("/verification_rejection_reasons", {
    params: { ...params },
  });

const getChallengeSignalTypes = async (params) =>
  await axiosInstance.get("/challenge_templates", { params: { ...params } });

export {
  getCities,
  getAreas,
  getCarMakes,
  getCarTypes,
  getCarModels,
  getStations,
  getTeams,
  getDrivers,
  getLevels,
  getMaintenanceTypes,
  getVerificationRequestsRejectionReasons,
  getChallengeSignalTypes,
};
